module.exports = __webpack_public_path__ + "img/petroleo3d.f9288743.jpg";